import { Container, Divider, Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';

import { DepressionGraph } from '../../assets';
import { useCommonStyles } from '../../root/theme';

const useStyles = makeStyles((theme: Theme) => {
  return {
    sectionHeight: {
      paddingTop: 120,
      paddingBottom: 120,
      [theme.breakpoints.down('sm')]: {
        paddingTop: 100,
        paddingBottom: 100,
      },
    },
    typographyContainer: {
      maxWidth: '700px',
      textAlign: 'left',
      paddingLeft: 20,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 40,
      },
    },
    header: {
      [theme.breakpoints.down('xs')]: {
        fontSize: 32,
      },
    },
    body: {
      [theme.breakpoints.down('xs')]: {
        fontSize: 20,
      },
    },
    graphContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      },
    },
    graph: {
      width: '95%',
      maxWidth: '600px',
      paddingLeft: 15,
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
      },
    },
  };
});

const TeenMentalHealthSection: React.FC = () => {
  const classes = useStyles({});
  const commonClasses = useCommonStyles({});

  return (
    <Container
      className={clsx(classes.sectionHeight, commonClasses.flexCenterContents)}
    >
      <Grid container className={commonClasses.flexCenterContents}>
        <Grid item sm={12} md={5} className={classes.typographyContainer}>
          <Typography
            variant="h2"
            color="textPrimary"
            className={classes.header}
          >
            Attention training is needed now more than ever
          </Typography>
          <Divider
            className={clsx(commonClasses.divider, commonClasses.dividerLeft)}
            variant="middle"
          />
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.body}
          >
            Teens are experiencing unprecedented levels of distraction, and
            rates of toxic stress and mental illness are increasing at alarming
            rates.
          </Typography>
        </Grid>
        <Grid item sm={12} md={7} className={classes.graphContainer}>
          <img
            src={DepressionGraph}
            alt="graph displaying percentage of teenagers who have experienced depression"
            className={classes.graph}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default TeenMentalHealthSection;
